module.exports = __webpack_public_path__ + "media/music/bells_4-743cec7f.mp3";